import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Award, TrendingUp, Users } from 'lucide-react';
export function InstructorsSection() {
  return <section className="py-24 bg-white text-slate-900" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4" data-id="element-106">
        <div className="text-center mb-16" data-id="element-107">
          <p className="text-amber-600 font-bold tracking-wider uppercase mb-2" data-id="element-108">
            Mentores
          </p>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-109">
            ¿Quiénes guían este entrenamiento?
          </h2>
          <p className="text-xl text-slate-700" data-id="element-110">
            Blas Miliani & Carolina Gómez
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-111">
          {/* Mentors Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-112">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border border-slate-200" data-id="element-113">
              <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768059311/Foto_mentores_u6buos.png" alt="Blas Miliani y Carolina Gómez - Mentores del entrenamiento" className="w-full h-auto object-cover" loading="lazy" data-id="element-114" />
            </div>

            {/* Stats floating card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="absolute -bottom-6 -right-6 bg-amber-500 p-6 rounded-xl shadow-xl hidden md:block max-w-xs" data-id="element-115">
              <p className="text-white font-bold text-lg leading-tight" data-id="element-116">
                +20 años viviendo el mundo de las ventas desde adentro.
              </p>
            </motion.div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-117">
            <div className="bg-amber-50 p-6 rounded-xl border-l-4 border-amber-500" data-id="element-118">
              <p className="text-lg font-semibold text-slate-900 mb-2" data-id="element-119">
                Ingenieros de formación. Estrategas por experiencia. Líderes por
                resultados.
              </p>
            </div>

            <div className="space-y-6 text-lg text-slate-700" data-id="element-120">
              <p data-id="element-121">
                Durante más de 20 años hemos vivido el mundo de las ventas desde
                adentro:
              </p>
              <ul className="space-y-4" data-id="element-122">
                <li className="flex items-start gap-3" data-id="element-123">
                  <Award className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" data-id="element-124" />
                  <span data-id="element-125">
                    Carrera corporativa en el sector petrolero (PDVSA).
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-126">
                  <TrendingUp className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" data-id="element-127" />
                  <span data-id="element-128">
                    15 años en venta directa, desde el terreno real: contactos
                    en frío, puerta a puerta, cierre tras cierre.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-129">
                  <Users className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" data-id="element-130" />
                  <span data-id="element-131">
                    Resultados que nos llevaron a entrenar presencialmente a
                    miles de personas en más de 5 países.
                  </span>
                </li>
              </ul>

              <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 my-8" data-id="element-132">
                <p className="italic text-slate-800 font-medium" data-id="element-133">
                  "No crecimos leyendo teoría. Crecimos ejecutando,
                  equivocándonos, corrigiendo y volviendo a avanzar."
                </p>
              </div>

              <div data-id="element-134">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-135">
                  Nuestra Misión Hoy
                </h3>
                <p className="mb-4" data-id="element-136">
                  Ayudar a profesionales de alto rendimiento a potenciar sus
                  resultados de forma estratégica, para que puedan:
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-137">
                  <span className="px-3 py-1 bg-amber-100 rounded-full text-sm text-amber-700 font-medium" data-id="element-138">
                    Crecer sin quemarse
                  </span>
                  <span className="px-3 py-1 bg-amber-100 rounded-full text-sm text-amber-700 font-medium" data-id="element-139">
                    Liderar sin cargarlo todo
                  </span>
                  <span className="px-3 py-1 bg-amber-100 rounded-full text-sm text-amber-700 font-medium" data-id="element-140">
                    Liberar tiempo real
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}